import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Message = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ sx, ...props }, ref) => (
    <SvgIcon
      viewBox="0 0 22 18"
      {...props}
      sx={{ fill: 'none', ...(sx || {}) }}
      ref={ref}
    >
      <path
        d="M1 4.42857L9.76667 10.44C10.1318 10.6906 10.561 10.8243 11 10.8243C11.439 10.8243 11.8682 10.6906 12.2333 10.44L21 4.42857M3.22222 17H18.7778C19.3671 17 19.9324 16.7592 20.3491 16.3305C20.7659 15.9019 21 15.3205 21 14.7143V3.28571C21 2.67951 20.7659 2.09812 20.3491 1.66947C19.9324 1.24082 19.3671 1 18.7778 1H3.22222C2.63285 1 2.06762 1.24082 1.65087 1.66947C1.23413 2.09812 1 2.67951 1 3.28571V14.7143C1 15.3205 1.23413 15.9019 1.65087 16.3305C2.06762 16.7592 2.63285 17 3.22222 17Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
);

Message.displayName = 'Message';
